import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockReferralSectionFields } from './groq';

/** Shared registry entry. Lazy: not on the critical rendering path. */
export const referralBlockConfig = {
  name: 'outer-block-referral',
  component: defineAsyncComponent(() => import('./CmsReferralSection.vue')),
  innerComponent: defineAsyncComponent(() => import('./ReferralBlock.vue')),
  fields: blockReferralSectionFields,
} satisfies ModularBlockConfig;
